import axios, { AxiosHeaders } from "axios";
import AuthService from "./auth.service";

// A 401 on a request that carried the user's token means the session is no
// longer valid. Unauthenticated 401s (e.g. a wrong OTP) are left to the caller.
export const isExpiredSessionError = (error) =>
  error?.response?.status === 401 &&
  AxiosHeaders.from(error.config?.headers ?? {}).has("Authorization");

export const handleExpiredSession = (error) => {
  if (isExpiredSessionError(error) && AuthService.getCurrentUser()) {
    AuthService.logout();
    window.location.assign("/login");
  }
  return Promise.reject(error);
};

export const registerSessionExpiryHandler = () =>
  axios.interceptors.response.use((response) => response, handleExpiredSession);
